import type { ReactNode } from 'react'

export type TabId =
  | 'overview'
  | 'scope'
  | 'settings'
  | 'infrastructure'
  | 'collections'
  | 'processing'
  | 'analysis'
  | 'custody'
  | 'history'
  | 'communications'

export interface Tab {
  id: TabId
  icon: ReactNode
}

export interface BadgeStyle {
  bg: string
  color: string
}

export const PRIORITY_BADGES: Record<string, BadgeStyle> = {
  critical: { bg: 'rgba(239, 68, 68, 0.12)', color: 'rgb(185, 28, 28)' },
  high: { bg: 'rgba(249, 115, 22, 0.12)', color: 'rgb(194, 65, 12)' },
  medium: { bg: 'rgba(132, 204, 22, 0.12)', color: 'rgb(77, 124, 15)' },
  low: { bg: 'var(--highlight, rgba(78,94,130,0.08))', color: 'var(--text-dim, #555c72)' },
}

export const STATUS_BADGES: Record<string, BadgeStyle> = {
  collection: { bg: 'var(--highlight, rgba(78,94,130,0.08))', color: 'var(--text-dim, #555c72)' },
  analysis: { bg: 'rgba(168, 85, 247, 0.12)', color: 'rgb(126, 34, 206)' },
  review: { bg: 'rgba(245, 158, 11, 0.12)', color: 'rgb(180, 83, 9)' },
  reporting: { bg: 'rgba(99, 102, 241, 0.12)', color: 'rgb(67, 56, 202)' },
  closed: { bg: 'var(--highlight, rgba(78,94,130,0.08))', color: 'var(--text-muted, #8e93a6)' },
  archived: { bg: 'var(--highlight, rgba(78,94,130,0.08))', color: 'var(--text-muted, #8e93a6)' },
}

export const DEFAULT_BADGE: BadgeStyle = {
  bg: 'var(--highlight, rgba(78,94,130,0.08))',
  color: 'var(--text-dim, #555c72)',
}
